define('MaxaPartPicker.Header.View', [
    'SCView',
    'eureka_maxapartpicker_header.tpl',
    'MaxaPartPicker.Collection'
], function (
    SCViewModule,
    eureka_maxapartpicker_header_tpl,
    MaxaPartPickerCollection,
) {
    'use strict';

    var SCView = SCViewModule.SCView;

    function MaxaPartPickerHeaderView (options) {
        SCView.call(this, options);
        var self = this;
        //console.log("options", options)
        this.template = eureka_maxapartpicker_header_tpl;
        if(options.models) {
            var result = options.models[0].attributes.imageModel

            if (!document.getElementById('type-breacrumb')) {
                var nameObject = [result.type, result.brand, result.model];
                setBreadCrumbs(nameObject)
            }
        }

    }

    function setBreadCrumbs(nameObject) {
        var toplevel = document.getElementsByClassName('global-views-breadcrumb')[0]
        var count = 0
        nameObject.forEach(function(name) {
            var liBreak = document.createElement('li');
            liBreak.appendChild(document.createTextNode(" > "))
            liBreak.classList.add('global-views-breadcrumb-item');
            toplevel.appendChild(liBreak);
            var liType = document.createElement('li');
            if(count === 0) {
                liType.id = "type-breacrumb"
                count++
            }
            liType.appendChild(document.createTextNode(name))
            liType.classList.add('global-views-breadcrumb-item');
            toplevel.appendChild(liType);
        })

    }

    MaxaPartPickerHeaderView.prototype = Object.create(SCView.prototype);
    MaxaPartPickerHeaderView.prototype.constructor = MaxaPartPickerHeaderView;

    MaxaPartPickerHeaderView.prototype.getContext = function () {
        return {
        }
    }

    return MaxaPartPickerHeaderView
})
